import { Label } from '../ui/label';
import './toggle-switch.scss';

interface ToggleProps {
	id: string;
	checked: boolean;
	options: [string, string];
	disabled?: boolean;
	onToggle: (checked: boolean) => void;
}

export const ToggleSwitch = ({
	id,
	checked,
	options,
	disabled,
	onToggle,
}: ToggleProps) => {
	return (
		<div className='toggle-switch'>
			<input
				type='checkbox'
				id={id}
				checked={checked}
				disabled={disabled}
				onChange={(e) => {
					onToggle(e.target.checked);
				}}
			/>
			<div className='content'>
				<Label htmlFor={id}>
					<div className='toggle' />
					<div className='options'>
						<p className={!checked ? 'on' : 'off'}>{options[0]}</p>
						<p className={checked ? 'on' : 'off'}>{options[1]}</p>
					</div>
				</Label>
			</div>
		</div>
	);
};
